import { Component, OnInit, Output, EventEmitter, TemplateRef, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { AddTouchesComponent } from 'src/app/middleware/common/addtouches/addtouches.component';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import * as jwt_decode from 'jwt-decode';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { Observable, Subscription } from 'rxjs';
import { FormsService } from 'src/app/applicationModules/eSignature/services/forms.service';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { ToastrService } from 'ngx-toastr';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { ShowDocumentDetails } from 'src/app/viewModels/core/delete-document-req-vm';
import { FormGroup, FormBuilder } from '@angular/forms';
import { element } from 'protractor';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/middleware/common/reusableComponents/confirm-dialog/confirm-dialog.component';
import { DocumentService } from 'src/app/applicationModules/core/services/coreService/document.service';
import { CoreService } from 'src/app/applicationModules/core/services/coreService/core.service';
import { DocType, ModuleName } from 'src/app/applicationModules/core/services/coreService/core.enum';
declare var require: any;
const FileSaver = require('file-saver');

@Component({
  selector: 'app-3cDocument-details',
  templateUrl: './3cDocument-details.component.html',
  styleUrls: ['./3cDocument-details.component.scss']
})
export class ThreeCDocumentdetailComponent implements OnInit {

  @Output() showShareFile = new EventEmitter<boolean>();
  @Output() closeEmit = new EventEmitter<boolean>();
  @Output() documentViewer = new EventEmitter<boolean>();
  @Output() openDocumentDetail = new EventEmitter<boolean>();
  @Output() openAIDetailfromDocDetails = new EventEmitter<any>();
  documentdetail = new ShowDocumentDetails();
  @Input() documentData: any;
  @Input() transactionID: any;


  showSidePanel: any = false;
  addNote: boolean = false;
  shareFile: boolean = true;
  closeDetail: boolean = false;

  organizationId: string;
  databaseId: string;
  currentUser: any;
  folderList: any[] = [];
  modulename: string;
  folderId: number = 0;
  documentID: number = 0;
  placeholderID: number = 0;
  documentPath: string = "";
  clickEventsubscriptionCoreDetails: Subscription;
  ResponseHolder: any;
  ResponseHolderDetails: any;
  AllCoreTouchesList: any[] = [];
  documentDetails: any[] = [];
  uploadHistory: any[] = [];
  responseHolderFile: any;
  responseHolder: any;
  formData: FormData;
  document: any;
  selectedFileArray: any = [];
  showAllDownloadButton: boolean = false;
  documentStatus: number;
  StatusCategoryForm: FormGroup;
  RequiredForm: FormGroup;
  showUploadedby: boolean = false;
  showAcceptedby: boolean = false;

  UploadedbyFirstName: string = "";
  UploadedbyLastName: string = "";
  UploadedDate: Date;

  AcceptedbyFirstName: string = "";
  AcceptedbyLastName: string = "";
  AcceptedDate: Date;

  urlforPlaceholder: string = "";

  StatusCategory = [{
    id: 0,
    name: 'Select Review Status',

  }, {
    id: 1,
    name: 'Under Review',

  }, {
    id: 2,
    name: 'Accepted',

  }, {
    id: 3,
    name: 'Rejected',
  }]
  docReviewHistoryList: any = [];
  docReviewerList: any = [];
  docReviewStatus: any;
  docReviewerListTop2: any = [];
  roleIdList: any = [];
  isReviewer: boolean = false;
  showTopTwoReviewer: boolean = true;
  showLocalPanel: boolean = false;
  placeholderType: number = 0;
  OfficeIDList: any = [];
  myOfficeID: any;
  projectName: string = "";
  projectID: number = 0;
  formType: number = 0;
  participantList: any = [];
  indexExpanded: number;
  showUpdateEmail: boolean = false;
  updatedParticpantEmail: string = "";
  placeholderName: string = "";
  expand: boolean = false;

  constructor(private coreService: CoreService, private formsService: FormsService, private dialog: MatDialog,
    private encryptionAlgo: EncryptionService, private statusConst: StatusConstant,
    private reusableClass: ReusableClasses, private _dataSharingService: DataSharingService,
    private toastr: ToastrService, private documentService: DocumentService,
    private loaderService: LoaderService, private fb: FormBuilder, private router: Router) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId');
    this.organizationId = sessionStorage.getItem('organizationID');
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.currentUser = jwt_decode(token);
    var offices = JSON.parse(sessionStorage.getItem('officeList'));
    offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID);
      if (oe.isMyoffice == true)
        this.myOfficeID = oe.officeID;
    });
    let roles = sessionStorage.getItem('roleIDList').split(',');
    roles.forEach(e => {
      this.roleIdList.push(Number(e));
    });
    this.documentdetail = new ShowDocumentDetails();
  }

  ngOnInit(): void {
    this.documentData;
    this.urlforPlaceholder = "";
    this.docReviewHistoryList = [];
    if (this.documentData.projectID > 0 && this.documentData.projectStatus == 3) {
      this.expand = false;
    } else {
      this.expand = true;
    }

    this.document = this.documentData;
    this.documentID = 0;
    if (this.documentData.coreDocumentID == undefined) {
      this.documentData.coreDocumentID = 0;
    }
    if (this.documentData.azureblobPath == undefined) {
      this.documentData.azureblobPath = "";
    }
    this.documentID = this.documentData.coreDocumentID;
    this.documentPath = this.documentData.azureblobPath;
    this.placeholderID = this.documentData.placeholderID;

    this.formType = this.documentData.formType;
    this.placeholderType = this.documentData.placeholderType;

    var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
    var Module = [];
    Module = menuModulesList.filter(x => x.mainModuleName == ModuleName.Core);
    if (Module.length > 0) {
      this.folderId = Module[0].folderID;
    }

    this.documentdetail = new ShowDocumentDetails();
    this.GetDocumentDetails();

    this.StatusCategoryForm = this.fb.group({
      status: [null]
    });
    this.RequiredForm = this.fb.group({
      isRequired: [''],
    });
    this.transactionID = this.transactionID;//sessionStorage.getItem('transactionID');

    if (environment.production) {
      this.showLocalPanel = false;
    } else {
      this.showLocalPanel = true;
    }
  }

  onTabClick(event) {
    if (event.tab.textLabel == "Notes" || event.index == 1) {
      this.AllCoreTouchesList = [];
      this.getAllTouchesList();
    }
  }

  capitalize(s) {
    if (s !== '' && s !== undefined && s !== null) {
      let nameArray = s.split(' ').length;
      if (nameArray.length > 1) {
        return nameArray[0].toUpperCase() + nameArray[1].toUpperCase();
      } else {
        return s[0].toUpperCase();
      }
    }
    else
      return '';
  }


  ShowReviwers(bool) {
    this.showTopTwoReviewer = bool;
  }

  //Get Document Details
  GetDocumentDetails() {
    this.docReviewHistoryList = [];
    this.docReviewerListTop2 = [];

    this.selectedFileArray = [];
    this.showAllDownloadButton = false;
    this.mergeButton = false;
    this.uploadHistory = [];
    this.projectName = "";
    // type (1-For Core,2-For Contact,3-For Company)
    var ReqModel = {
      placeholderID: this.placeholderID,
      documentID: this.documentID,
      userID: this.currentUser.UID,
      type: DocType.Core,//1,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId)
    }
    this.docReviewStatus = 0;
    this.coreService.GetDocumentDetails(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.ResponseHolderDetails = response;
        if (response.data.documentDeatilModel !== null && response.data.documentDeatilModel.url !== null) {
          this.urlforPlaceholder = response.data.documentDeatilModel.url
        }
        if (this.ResponseHolderDetails.status == this.statusConst.statusSuccess) {
          this.projectName = response.data.projectName;
          this.placeholderName = response.data.placeholderName;

          if (this.projectName == "None" || this.projectName == undefined || this.projectName == null || this.projectName == '') {
            this.projectName = "";
          }
          if (this.placeholderName == undefined || this.placeholderName == null || this.placeholderName == '') {
            this.placeholderName = "";
          }
          this.projectID = response.data.projectID > 0 ? response.data.projectID : 0;
          //if(this.projectID>0 && response.data.projectStatus>0){
          if (this.projectID > 0) { // Bind Groups
            this.loaderService.show();
            this.bindParticipant()
          } else {
            this.participantList = [];
          }
          this.ResponseHolderDetails = response.data.uploadHistory;
          this.documentdetail = response.data.documentDeatilModel;
          if (this.documentdetail == null || this.documentDetails == undefined) {
            return;
          }
          this.documentID = this.documentdetail.documentID;
          this.documentPath = this.documentdetail.documentPath;
          this.docReviewHistoryList = response.data.docReviewHistoryList;
          if (this.docReviewHistoryList.length > 0) {
            this.documentStatus = this.docReviewHistoryList[0].status
            if (this.documentStatus == 2 || this.documentStatus == 3) {
              this.AcceptedbyFirstName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, this.docReviewHistoryList[0].firstName);
              this.AcceptedbyLastName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, this.docReviewHistoryList[0].lastName);
            }
          } else {
            this.documentStatus = 0;
          }

          this.docReviewerList = response.data.docReviewerList;
          this.isReviewer = this.docReviewerList.some(m => m.userID == this.currentUser.UID);
          this.docReviewerList.forEach(e => {
            e.userEmail = this.encryptionAlgo.get(this.reusableClass.decryptionKey, e.userEmail);
            e.userFName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, e.userFName);
            e.userLName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, e.userLName);
            e.userName = e.userFName + ' ' + e.userLName;

            if (e.userFName == '' || e.userFName == undefined || e.userFName == null) {
              e.sn = this.capitalize(e.roleName);
              e.userName = e.roleName;
            } else {
              e.sn = this.capitalize(e.userFName) + this.capitalize(e.userLName);
            }
          });
          if (this.docReviewerList.length > 2) {
            this.docReviewerListTop2.push(this.docReviewerList[0])
            this.docReviewerListTop2.push(this.docReviewerList[1])
          } else {
            this.docReviewerListTop2 = [];
          }
          // this.docReviewerCount=this.docReviewerList.length+(this.showAcceptedby==true?1:0);
          //this.documentStatus = (this.documentdetail.documentStatus);
          this.UploadedbyFirstName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, this.documentdetail.uploadedByFirstName);
          this.UploadedbyLastName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, this.documentdetail.uploadedByLastName);
          // this.AcceptedbyFirstName=this.encryptionAlgo.get(this.reusableClass.decryptionKey, this.documentdetail.statusChangedByFirstName);
          // this.AcceptedbyLastName=this.encryptionAlgo.get(this.reusableClass.decryptionKey, this.documentdetail.statusChangedByLastName);

          if (this.documentStatus == 1 || this.documentStatus == 0) {
            this.showAcceptedby = false;
            this.showUploadedby = true;
          }
          if (this.documentStatus == 2 || this.documentStatus == 3) {
            this.showAcceptedby = true;
            this.showUploadedby = true;
          }
          this.RequiredForm.get('isRequired').setValue(this.documentdetail.isRequired);
          if (this.ResponseHolderDetails != null) {
            this.ResponseHolderDetails.map((res) => {
              if (res.createdByFirstName != null) {
                res.createdByFirstName = this.encryptionAlgo.get(
                  this.reusableClass.decryptionKey, res.createdByFirstName);
              }
              if (res.createdByLastname != null) {
                res.createdByLastname = this.encryptionAlgo.get(
                  this.reusableClass.decryptionKey, res.createdByLastname);
              }
              // if (res.documentPath != null) {
              //   res.documentName = res.documentPath.split('/').pop(); 
              //   res.documentName = res.documentName.split('.');
              //   res.documentName = decodeURIComponent(res.documentName[0]);
              // }
              return res;
            });
          }
          this.uploadHistory = this.ResponseHolderDetails == null ? [] : this.ResponseHolderDetails;
          if (this.uploadHistory.length > 0) {
            this.uploadHistory.forEach(s => s.checked = false);
            var lastElement = [];
            lastElement = this.uploadHistory.slice(-1);
            if (lastElement.length > 0) {
              this.documentID = lastElement[0].documentID;
            }
          }

        }
        else {
          this.uploadHistory = [];
        }
      }
    });
  }


  // Remove Group Relation 
  deleteParticipant(p: any) {
    const message = `Are you sure you want to delete this group participant ?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message, confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {
          this.loaderService.show();
          var ReqModel = {
            groupRelationParticipantMappingID: p.groupRelationParticipantMappingID,
            userID: this.currentUser.UID,
            databaseID: Number(this.databaseId),
            organizationID: Number(this.organizationId),
            type: 1,// 1 for Project and 2 for Template
          }
          this.coreService.RemoveGroupRelation(ReqModel).subscribe((response) => {
            if (response != undefined) {
              this.responseHolder = response;
              if (this.responseHolder.status == this.statusConst.statusSuccess) {
                this.loaderService.hide();
                this.bindParticipant();
                this.toastr.success('Group participant remove successfully.', '', {
                  timeOut: 3000,
                });
              }
            } else {
              this.loaderService.hide();
            }
          });
        }
      } catch (e) {
        //Observable.throw(e);
      }
    });
  }


  bindParticipant() {
    var ReqModel = {
      projectID: this.projectID,
      projectInboxSentID: 0,
      emailFieldID: 0,
      nameFieldID: 0,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID
    }
    this.formsService.GetSentBoxItemParticipantList(ReqModel).subscribe(response => {
      if (response.data != null) {
        //this.formsService.setIsprojectExtended(false);   
        this.participantList = response.data;
        this.participantList.forEach(e => {
          e.getProjectGroupRelationParticipantMappingModelList.forEach(n => {
            n.enableEmailEdit = false;
            n.signingToken = window.location.href.split(window.location.pathname)[0] + "/request/signature?token=" + n.signingToken
          });
        });
        this.loaderService.hide();
      }
    });
  }

  ResendEmail(participantDetails: any, isUpdateDetails: boolean = false) {
    this.loaderService.show();
    let reqModel = {
      GroupRelationParticipantMappingID: participantDetails.groupRelationParticipantMappingID,
      participantEmail: participantDetails.participantEmail,
      ProjectID: this.projectID,
      userID: this.currentUser.UID,
      organizationID: this.organizationId,
      databaseID: this.databaseId,
      contactId: participantDetails.contactID,
      isUpdateDetails: isUpdateDetails
    }
    this.formsService.ResendEmail(reqModel).subscribe(response => {
      this.loaderService.hide();
      if (response) {
        this.toastr.success('The reminder has been sent.');
        if (isUpdateDetails == true) {
          this.getParticipantDetails();
        }
      } else {
        this.toastr.warning('The project group is not active yet.');
      }
    });
  }

  getParticipantDetails() {
    var ReqModel = {
      projectID: this.projectID,
      projectInboxSentID: 0,
      emailFieldID: 0,
      nameFieldID: 0,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID
    }
    this.formsService.GetSentBoxItemParticipantList(ReqModel).subscribe(response => {
      if (response.data != null) {
        this.formsService.setIsprojectExtended(false);
        this.participantList = response.data;
        this.participantList.forEach(e => {
          e.getProjectGroupRelationParticipantMappingModelList.forEach(n => {
            n.enableEmailEdit = false;
            n.signingToken = window.location.href.split(window.location.pathname)[0] + "/request/signature?token=" + n.signingToken
          });
          //e.signHref=window.location.href.split(window.location.pathname)[0]+"/request/signature?token="+e.signingToken
        });


      }
      else {
      }
    });
  }

  EditParticipantEmail(participantDetails: any, event: any) {
    if (event.target.value == "") {
      this.showUpdateEmail = !this.showUpdateEmail;
      participantDetails["showUpdateEmail"] = this.showUpdateEmail;
      this.toastr.error('Please provide email');
      return;
    }
    if (participantDetails.contactEmail == event.target.value.trim() || participantDetails.participantEmail == event.target.value.trim()) {
      this.showUpdateEmail = !this.showUpdateEmail;
      this.toastr.error('Please provide different email to update.');
      return;
    } else if (event.target.value != "") {
      this.loaderService.show();
      let reqModel = {
        GroupRelationParticipantMappingID: participantDetails.groupRelationParticipantMappingID,
        ProjectID: this.projectID,
        userID: this.currentUser.UID,
        organizationID: this.organizationId,
        databaseID: this.databaseId,
        contactId: participantDetails.contactID,
        ModifiedParticipantEmail: event.target.value.trim(),
        PreviousParticipantEmail: participantDetails.contactEmail == '' ? participantDetails.participantEmail : participantDetails.contactEmail
      }
      this.formsService.EditParticipantEmail(reqModel).subscribe(respnse => {
        this.loaderService.hide();
        if (respnse) {
          this.showUpdateEmail = !this.showUpdateEmail;
          if (participantDetails.contactEmail != '')
            participantDetails.contactEmail = event.target.value.trim();
          if (participantDetails.participantEmail != '')
            participantDetails.participantEmail = event.target.value.trim();
          this.updatedParticpantEmail = "";
          participantDetails["showUpdateEmail"] = this.showUpdateEmail;
          this.toastr.success('Email updated successfully');
          this.getParticipantDetails();
        }
      });
    }
  }



  ReopenSignatureLink(participantDetails: any) {

    this.loaderService.show();
    let reqModel = {
      GroupRelationParticipantMappingID: participantDetails.groupRelationParticipantMappingID,
      participantEmail: participantDetails.participantEmail,
      ProjectID: this.projectID,
      userID: this.currentUser.UID,
      organizationID: this.organizationId,
      databaseID: this.databaseId,
      contactId: participantDetails.contactID
    }
    this.formsService.ReopenSignatureLink(reqModel).subscribe(response => {
      this.loaderService.hide();
      if (response) {
        this.toastr.success('Signing link opened successfully');
      } else {
        this.toastr.error('Request failed');
      }
    });
  }

  editEmail(p, val) {
    p.enableEmailEdit = val;
  }

  getShortName(fullName) {
    var name = fullName;
    if (name != null || name != undefined) {
      return fullName.split(' ').map(n => n[0]).join('');
    } else {
      return '';
    }
  }

  togglePanels(index: number) {
    this.indexExpanded = index;
  }

  getdocumentName(documentName) {
    var x = documentName;
    var f = x.replace(/\..+$/, '');
    return f;
  }

  ChangeProjectName(event: any) {
    if (event.target.value.trim() != '' && this.projectID > 0) {
      this.loaderService.show();
      let ReqModel = {
        ProjectName: event.target.value,
        userID: this.currentUser.UID,
        ProjectID: this.projectID,
        organizationID: Number(this.organizationId),
        databaseID: Number(this.databaseId)
      }
      this.coreService.RenameProjectName(ReqModel).subscribe(response => {
        if (response != undefined) {
          this.ResponseHolderDetails = response;
          if (this.ResponseHolderDetails.status == this.statusConst.statusSuccess) {
            this.toastr.success("Project renamed successfully.")
            this.loaderService.hide();
          }
          else {
            this.loaderService.hide();
          }
        }
      });
    }
  }
  // mark Document required 
  onChangeDocumentRequired(formValues) {
    if (formValues.isRequired == null || formValues.isRequired == undefined) {
      formValues.isRequired = false;
    }
    var ReqModel = {
      placeholderID: this.placeholderID,
      isRequired: formValues.isRequired,
      userID: this.currentUser.UID,
      //documentID:this.documentID,      
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId)
    }
    this.coreService.MakeDocumentRequired(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.ResponseHolderDetails = response;
        if (this.ResponseHolderDetails.status == this.statusConst.statusSuccess) {
          //this._dataSharingService.sendClosePanelFromDocDetailsCore(true);
          // this.getAllTouchesList();
        }
        else {
          // this.uploadHistory = [];
        }
      }
    });
  }


  // Document Status change
  onChangeDocumentStatus(event) {
    if (event.value == 0) {
      this.StatusCategoryForm.get('status').setValue(0);
      this.toastr.warning('Please select valid doc review status', '', {
        timeOut: 3000,
      });
      return;
    }

    if (event.value == 1) {
      this.StatusCategoryForm.get('status').setValue(0);
      this.toastr.warning('Please Accept or Reject doc.', '', {
        timeOut: 3000,
      });
      return;
    }
    var ReqModel = {
      userID: this.currentUser.UID,
      documentID: this.documentID,
      status: event.value,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      OfficeIDList: this.OfficeIDList
    }
    var docStatusObj = {
      coreID: Number(this.transactionID),//Number(sessionStorage.getItem('transactionID')),
      documentID: this.documentID,
      placeholderID: this.placeholderID,
      status: event.value,
      oleID: this.roleIdList,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      OfficeIDList: this.OfficeIDList
    };
    this.coreService.ChangeStatusCoreDocumentByReviewer(docStatusObj).subscribe(response => {
      if (response != undefined) {
        this.ResponseHolderDetails = response;
        if (this.ResponseHolderDetails.status == this.statusConst.statusSuccess) {
          this.coreService.ChangeDocumentStatus(ReqModel).subscribe(response => {
            if (response != undefined) {
              this.ResponseHolderDetails = response;
              if (this.ResponseHolderDetails.status == this.statusConst.statusSuccess) {
                this.GetDocumentDetails();
                // this._dataSharingService.sendClosePanelFromDocDetailsCore(true);
                //this.getAllTouchesList();
                this.toastr.success('Review Status Changed Successfully', '', {
                  timeOut: 3000,
                });
              }
              else {
                this.StatusCategoryForm.get('status').setValue(0);
                this.toastr.error('Error Occured.', '', {
                  timeOut: 3000,
                });
              }
            }
          });
        }
        else if (this.ResponseHolderDetails.status == 2) {
          this.StatusCategoryForm.get('status').setValue(0);
          this.toastr.warning('You are not added as a reviewer.', '', {
            timeOut: 3000,
          });
        }
        else if (this.ResponseHolderDetails.status == 500) {
          this.StatusCategoryForm.get('status').setValue(0);
          this.toastr.warning('You are not added as a reviewer.', '', {
            timeOut: 3000,
          });
        }
        else {
          this.StatusCategoryForm.get('status').setValue(0);
          this.toastr.error('Error Occured.', '', {
            timeOut: 3000,
          });
        }
      }

    });
  }


  UploadFile(event: any) {
    if (event.target.files.length > 0) {
      this.UploadCoreDocument(event, this.document);
    } else {
    }
  }

  // on upload file
  UploadCoreDocument(event, document) {
    this.formData = new FormData();
    let files = event.target.files;
    if (files !== '' && files !== null && files != undefined) {
      let documentType = files[0].name.split('.').pop();
      this.formData.append('file', files[0]);
      this.formData.append('DocumentType', documentType);
    } else {
      this.toastr.warning('Please select document');
      return;
    }
    this.formData.append('PlaceholderID', document.placeholderID);
    this.formData.append('DocumentId', '0');
    //this.formData.append('DocumentId', document.documentFolderID);   
    this.formData.append('UserID', this.currentUser.UID);
    this.formData.append('DatabaseID', this.databaseId);
    this.formData.append('OrganizationID', this.organizationId);
    this.formData.append('DocumentName', "");
    this.formData.append('DocumentString', '');
    this.loaderService.show();
    this.documentService.UploadCoreDocument(this.formData).subscribe((response) => {
      if (response != undefined) {
        this.responseHolderFile = response;
        if (this.responseHolderFile.status == this.statusConst.statusSuccess) {
          this.loaderService.hide();
          this.GetDocumentDetails();
          // this._dataSharingService.sendClosePanelFromDocDetailsCore(true);
          this.toastr.success('File upload successfully.', '', {
            timeOut: 3000,
          });
        } else {
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });
  }

  //download Single File
  DownloadSigleFile(history) {
    const selectedFileName = history.documentPath.split('/').pop();
    this.documentService.getAttachment(selectedFileName, history.documentPath).subscribe((response) => {
      if (response !== undefined) {
        const data = 'data:' + response.data.contentType + ';base64,' + response.data.base64URL;
        FileSaver.saveAs(data, selectedFileName);
      } else {
        this.toastr.error('File download failed.', '', {
          timeOut: 3000,
        });
      }
    });
  }


  //download selected File
  downloadSelectedFile() {
    this.selectedFileArray = [];
    this.uploadHistory.forEach(s => {
      if (s.checked) {
        this.selectedFileArray.push(s);
      }
    });
    for (let i = 0; i < this.selectedFileArray.length; i++) {
      const selectedFileName = this.selectedFileArray[i].documentPath.split('/').pop();
      this.documentService.getAttachment(selectedFileName, this.selectedFileArray[i].documentPath).subscribe((response) => {
        if (response !== undefined) {
          const data = 'data:' + response.data.contentType + ';base64,' + response.data.base64URL;
          //FileSaver.saveAs(data, selectedFileName);
        } else {
          this.toastr.error('File download failed.', '', {
            timeOut: 3000,
          });
        }
      });
    }
    this.selectedFileArray = [];
    this.showAllDownloadButton = false;
    this.mergeButton = false;
    this.uploadHistory.forEach(s => s.checked = false);
  }



  checkUploadHistoryElement(event, history) {
    this.uploadHistory.forEach(s => {
      if (s.documentLogID == history.documentLogID) {
        s.checked = event.checked;
      }
    });
    this.uploadHistory.forEach(s => {
      if (s.checked) {
        this.showAllDownloadButton = true;
      }
    });

    this.showAllDownloadButton = true;
    let ReqModel = {
      selectedDocument: history,
    };

    if (event.checked) {
      this.selectedFileArray.push(ReqModel);
    } else {
      let removeIndex = this.selectedFileArray.findIndex((itm) => itm.selectedDocument === history);

      if (removeIndex !== -1) this.selectedFileArray.splice(removeIndex, 1);
    }

    if (this.selectedFileArray.length == 0) {
      this.showAllDownloadButton = false;
    }

    var checkMerge = [];
    checkMerge = this.uploadHistory.filter(x => x.checked == true);
    if (checkMerge.length >= 2) {
      this.mergeButton = true;
    } else {
      this.mergeButton = false;
    }
  }



  addTouch() {
    const dialogRef = this.dialog.open(AddTouchesComponent, {
      data: {
        moduleName: ModuleName.Core,
        folderID: 2,//this.folderId, {{Main=1;Item=2;}}
        documentID: this.documentID,
        placeholderID: this.placeholderID
      },
      panelClass: 'autoFill-modalbox'
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result != null && result != undefined) {
        this.getAllTouchesList();
      }
    });
  }


  // get Activity List
  getAllTouchesList() {
    var ReqModel = {
      folderID: this.folderId,
      transactionID: Number(this.transactionID),//Number(sessionStorage.getItem('transactionID')),
      placeholderID: this.placeholderID,
      documentID: this.documentID,
      organizationID: Number(this.organizationId),
      databaseId: Number(this.databaseId),
      userID: this.currentUser.UID
    }
    this.coreService.GetAllCoreTouches(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.ResponseHolder = response;
        if (this.ResponseHolder.status == this.statusConst.statusSuccess) {
          this.ResponseHolder = response.data;
          if (this.ResponseHolder != null) {
            this.ResponseHolder.map((res) => {
              if (res.createdByFirstName != null) {
                res.createdByFirstName = this.encryptionAlgo.get(
                  this.reusableClass.decryptionKey, res.createdByFirstName);
              }
              if (res.createdByLastName != null) {
                res.createdByLastName = this.encryptionAlgo.get(
                  this.reusableClass.decryptionKey, res.createdByLastName);
              }
              return res;
            });
          }
          this.AllCoreTouchesList = this.ResponseHolder;
        }
        else {
          this.AllCoreTouchesList = [];
        }
      }
    });
  }

  //open document detail panel
  documentDetail() {
    this.showSidePanel = !this.showSidePanel;
  }

  openDocumentViewer(message: boolean, history,templateRef: TemplateRef<any>) {
    var ReqModel = {
      Fromdetail: true,
      placeholderID: this.placeholderID,
      documentFolderID: history.documentID,
      documentName: history.documentName,
      documentPath: history.documentPath,
      fileType: history.fileType,
      fileSize: history.fileSize,
      createdOn: history.createdOn
    }
    this.selectedDocument = ReqModel;
    this.transactionID = this.transactionID;
    this.openDocumentViewers = true;
    this.dialog.open(templateRef);

    //  this.AllCoreTouchesList = [];
    // this.selectedFileArray = [];
    // this.showAllDownloadButton = false;
    // this.mergeButton = false;
    // this.uploadHistory = [];
    // this.urlforPlaceholder = "";
    // this.closeEmit.emit(false);
    // this._dataSharingService.sendSelectedDocumentForCore(ReqModel);
    // this.documentViewer.emit(true);
    // this.closeEmit.emit(false);
  }

  shareFiles(message: boolean) {
    this.showShareFile.emit(message);
  }

  addReviewer(templateRef: TemplateRef<any>) {
    this.dialog.open(templateRef);
  }

  addSign(templateRef: TemplateRef<any>) {
    this.dialog.open(templateRef, {
      panelClass: 'signatureModal',
    });
  }

  assignUser(templateRef: TemplateRef<any>) {
    this.dialog.open(templateRef);
  }

  closedocumentDetail(closeDetail: boolean) {
    this.AllCoreTouchesList = [];
    this.selectedFileArray = [];
    this.showAllDownloadButton = false;
    this.mergeButton = false;
    this.uploadHistory = [];
    this.urlforPlaceholder = "";
    this.closeEmit.emit(closeDetail);

  }

  close() {
    this.AllCoreTouchesList = [];
    this.dialog.closeAll();
  }


  onChange(searchValue: string) {
    if (searchValue == "" || this.projectID == 0) {
      return;
    }

    this.projectName = searchValue.trim();

    var ReqModels = {
      projectName: searchValue.trim(),
      projectID: this.projectID,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      databaseID: Number(this.databaseId),
    }
    this.coreService.CheckProjectName(ReqModels).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.data == false) {
          this.toastr.warning(this.responseHolder.message, '', {
            timeOut: 3000,
          });
          //  this.toastr.warning('Project name already exist.', '', {
          //   timeOut: 3000,
          //  });
        } else {
          this.RenameProjectName();
        }
      } else {

      }
    });

  }

  onFormURLChange(formValue: any) {
    var ReqModels = {
      placeholderID: this.placeholderID,
      url: formValue,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      databaseID: Number(this.databaseId),
    }
    this.coreService.AddSavedURL(ReqModels).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data == true) {
          this.toastr.success('Your Changes are saved', '', {
            timeOut: 3000,
          });
          this.GetDocumentDetails();
        } else {
          this.urlforPlaceholder = "";
          this.toastr.warning('Your Changes are not saved', '', {
            timeOut: 3000,
          });
        }
      } else {
        this.urlforPlaceholder = "";
        alert(this.responseHolder.status);
      }
    });

  }

  openSavedURL() {
    this.router.navigate([]).then(result => { window.open(this.urlforPlaceholder, '_blank'); });
  }

  RenameProjectName() {
    if (this.projectName == "" || this.projectID == 0) {
      return;
    }
    var ReqModels = {
      projectName: this.projectName.trim(),
      projectID: this.projectID,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      databaseID: Number(this.databaseId),
    }
    this.coreService.RenameProjectName(ReqModels).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.toastr.success('Project name rename successfully.', '', {
            timeOut: 3000,
          });
        } else {

        }
      } else {
      }
    });

  }

  savePlaceHolderName() {
    if (this.placeholderName == "") {
      this.toastr.warning('Please Enter Placeholder name.', '', {
        timeOut: 3000,
      });
      return;
    }
    var ReqModels = {
      name: this.placeholderName,
      placeholderID: this.placeholderID,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      databaseID: Number(this.databaseId),
    }
    this.coreService.renamecoreplaceholder(ReqModels).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.toastr.success('Placeholder rename successfully.', '', {
            timeOut: 3000,
          });
          //this._dataSharingService.sendClosePanelFromDocDetailsCore(true);
        } else {
          this.toastr.error('Placeholder rename Failed.', '', {
            timeOut: 3000,
          });
        }
      } else {
        this.toastr.error('Placeholder rename Failed.', '', {
          timeOut: 3000,
        });
      }
    });

  }


  todo = [
    {
      role: 'Employee',
      color: 'primary'
    }
  ];

  done = [
    {
      role: 'Admisssion',
      color: 'warn'
    }
  ];

  drop(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex);
    }
  }


  mergeButton: boolean = false;

  //merge selected File
  mergeSelectedFile() {
    this.selectedFileArray = [];
    this.uploadHistory.forEach(s => {
      if (s.checked) {
        this.selectedFileArray.push(s.documentPath);
      }
    });
    this.loaderService.show();
    this.documentService.mergePdfFiles(this.selectedFileArray).subscribe((response) => {
      if (response !== undefined) {
        if (response.data != null) {
          const data = 'data:' + "application/pdf" + ';base64,' + response.data;
          FileSaver.saveAs(data, this.placeholderName);

          this.loaderService.hide();

          this.selectedFileArray = [];
          this.showAllDownloadButton = false;
          this.mergeButton = false;
          this.uploadHistory.forEach(s => s.checked = false);
        } else {
          this.toastr.error('File download failed.', '', {
            timeOut: 3000,
          });
          this.loaderService.hide();

          this.selectedFileArray = [];
          this.showAllDownloadButton = false;
          this.mergeButton = false;
          this.uploadHistory.forEach(s => s.checked = false);
        }

      } else {
        this.toastr.error('File download failed.', '', {
          timeOut: 3000,
        });
        this.loaderService.hide();

        this.selectedFileArray = [];
        this.showAllDownloadButton = false;
        this.mergeButton = false;
        this.uploadHistory.forEach(s => s.checked = false);
      }
    });

  }

  fileNameEdit: string = "";
  fileNameEditExtension: string = "";
  formDialog: FormGroup;
  documentIDForEdit: number = 0;
  spinner: boolean = false;

  EditFile(templateRef: TemplateRef<any>, type: any) {
    let group = {};
    this.formDialog = new FormGroup(group);
    this.formDialog.addControl('documentName', this.fb.control(''));
    var docname = type.documentName.split('.');
    this.fileNameEdit = docname[0];
    this.fileNameEditExtension = docname[1];
    this.documentIDForEdit = type.documentID;
    this.dialog.open(templateRef, {
    });
    this.formDialog.markAsPristine();
  }

  renameDocument() {
    this.spinner = true;
    this.formDialog.markAsPristine();
    this.loaderService.show();
    var ReqModel = {
      documentID: this.documentIDForEdit,
      documentName: this.fileNameEdit + "." + this.fileNameEditExtension,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
      OfficeIDList: this.OfficeIDList
    }
    this.documentService.renameCoreDocument(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.spinner = false;
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.dialog.closeAll();
          this.toastr.success('Record updated successfully.', '', {
            timeOut: 3000,
          });
          this.GetDocumentDetails();
          this.loaderService.hide();
        } else {
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });
  }

  closeEditDoc() {
    this.dialog.closeAll();
  }

  showBindingFieldDetail(document) {
    // this.azureblobPath=document.azureblobPath;
    // this.documentsId= document.fileManagerItemID;
    // this.documentNames = document.name;   
    this.openAIDetailfromDocDetails.emit(document);
  }

  groupList: any = [];

  deleteSelectedFile() {
    const message = `Are you sure you want to delete selected file?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message, confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });

    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {
          this.selectedFileArray = [];
          this.uploadHistory.forEach(s => {
            if (s.checked) {
              this.selectedFileArray.push(s);
            }
          });
          for (let i = 0; i < this.selectedFileArray.length; i++) {

          }

          var ReqModel = {
            databaseID: Number(this.databaseId),
            userID: this.currentUser.UID,
            documentIDs: this.groupList,
            officeID: this.myOfficeID,
            officeIDList: this.OfficeIDList,
          }
          this.loaderService.show();
          this.documentService.deleteDocument(ReqModel).subscribe((response) => {
            if (response != undefined) {
              this.responseHolder = response;
              if (this.responseHolder.status == this.statusConst.statusSuccess) {
                this.selectedFileArray = [];
                this.GetDocumentDetails();
                this.loaderService.hide();
                this.toastr.success('Selected File deleted successfully.', '', {
                  timeOut: 3000,
                });
              } else {
                this.loaderService.hide();
                this.toastr.error('Selected file deletion failed.', '', {
                  timeOut: 3000,
                });
              }
            } else {
              this.loaderService.hide();
              this.toastr.error('Selected file deletion failed.', '', {
                timeOut: 3000,
              });
            }
          });
        }
      } catch (e) {
        Observable.throw(e);
      }
    });
  }

  openDocumentViewers: boolean = false;
  selectedDocument: any;

  //  showDocumentViewerDetails(data:any,core:any){  
  //   this.selectedDocument = data;
  //   this.transactionID = core.coreID;
  //   this.openDocumentViewers=true;
  //    this.AllCoreTouchesList = [];
  //   this.selectedFileArray = [];
  //   this.showAllDownloadButton = false;
  //   this.mergeButton = false;
  //   this.uploadHistory = [];
  //   this.urlforPlaceholder = "";


  //   //this.closeEmit.emit(false);
  // }

  getCloseDocumentViewer(closeDetail: boolean) {
    this.openDocumentViewers = false;
    this.dialog.closeAll();
  }

  getSignedCount(group: any): number {
    return group.getProjectGroupRelationParticipantMappingModelList
      .filter((p: any) => p.hasCompleted === true && !p.isApprover)
      .length;
  }

  getStatusLabel(p: any): string {
    if (p.hasCompleted && p.isApprover) return 'Approved';
    if (p.hasCompleted && !p.rejectionMessage) return 'Signed';
    if (p.rejectionMessage) return 'Declined';
    if (p.hasViewed && !p.hasCompleted) return 'Viewed';
    if (p.isEmailSent && !p.hasViewed) return 'Sent';
    return 'Not Sent';
  }

  getStatusClass(p: any): string {
    if (p.hasCompleted && p.isApprover) return 'approved';
    if (p.hasCompleted && !p.rejectionMessage) return 'signed';
    if (p.rejectionMessage) return 'declined';
    if (p.hasViewed) return 'viewed';
    if (p.isEmailSent) return 'sent';
    return 'not-sent';
  }

}
